import React, { useMemo } from 'react';
import { Box, Hint, Inscription, PayoutRuleType } from '@common-fe/common-fe';
import { InfoOutlineIcon } from '@common-fe/common-fe';
import styled from 'styled-components';

import { PAYOUT_RULE_OPTIONS } from './tierItem.types';

const StyledInfoIcon = styled(InfoOutlineIcon)`
  cursor: pointer;
`;

interface PayoutRulesCardProps {
  payoutRuleType?: PayoutRuleType;
}

export const PayoutRulesCard: React.FC<PayoutRulesCardProps> = ({ payoutRuleType }) => {
  const option = useMemo(
    () => PAYOUT_RULE_OPTIONS.find((opt) => opt.key === payoutRuleType),
    [payoutRuleType]
  );

  return (
    <Box width="35%">
      <Inscription color="textBody" size="large" lineHeight="22px" margin={{ bottom: 's' }}>
        Payout rules
      </Inscription>
      <Box background="module" pad="s" round="container1Round">
        <Box
          pad={{ vertical: 'spacing16', horizontal: 'spacing16' }}
          round="container2Round"
          background="canvas"
          border={{ color: 'border2', size: '1px' }}
          height="52px"
          direction="row"
          align="center"
          gap="spacing8"
        >
          <Inscription color="textBody" lineHeight="20px">
            {option?.value || payoutRuleType || '—'}
          </Inscription>
          {option?.hintIconText && (
            <Hint
              hintAlign="right"
              hintWidth={220}
              hintElement={<StyledInfoIcon color="iconDisabled" />}
              testId="payout-rules-hint"
            >
              <Inscription size="12px" weight={500}>
                {option.hintIconText}
              </Inscription>
            </Hint>
          )}
        </Box>
      </Box>
    </Box>
  );
};
